const XHR = {
    load({ nodeIds, url = window.location, functionCall = null }) {
        const xhr = new XMLHttpRequest();
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    // Build new content
                    let html          = xhr.responseText;
                    let mainContent   = html.match(/(?=<main>).*?(<\/main>)/gs);
                    let tempDOM       = document.createElement('html');
                    tempDOM.innerHTML = `<html>${mainContent}</html>`;
                    // Multiple Ids possible
                    if (Array.isArray(nodeIds) ) {
                        nodeIds.forEach(nodeId => {
                            let responseNode  = tempDOM.querySelector(`#${nodeId}`);
                            let refreshNode   = document.getElementById(nodeId);
                            if (responseNode === null || refreshNode === null) {
                                (responseNode === null) && console.log(`responseNode is null`);
                                (refreshNode === null) && console.log(`refreshNode is null`);
                                return;
                            }
                            // Put new content into site
                            refreshNode.innerHTML = responseNode.innerHTML;
                        });
                    } else {
                        console.log('Error: You must provide an array of ids!');
                    }
                    // Call Functions
                    if ( functionCall !== null && Array.isArray(functionCall) ) {
                        functionCall.forEach(call => {
                            call();
                        });
                    }
                } else if (xhr.status === 400) {
                    console.log('XHR Status: 400');
                } else {
                    console.log('XHR Status: Something else other than 200 was returned');
                }
            }
        };
        // Asynchron
        xhr.open('GET', url, true);
        xhr.send();
    }
}